'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

require('../styles/ToggleSwitch.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToggleSwitch = function ToggleSwitch(_ref) {
  var active = _ref.active,
      handleClick = _ref.handleClick,
      children = _ref.children,
      className = _ref.className,
      activeLocaleKey = _ref.activeLocaleKey,
      inactiveLocaleKey = _ref.inactiveLocaleKey;

  var switchClass = active ? 'active' : 'inactive';
  var localeKey = active ? activeLocaleKey : inactiveLocaleKey;
  return _react2.default.createElement(
    'button',
    {
      'aria-pressed': active,
      className: 'cp-toggle-switch ' + className + ' ' + switchClass,
      onClick: handleClick },
    _react2.default.createElement(
      'div',
      { className: 'path' },
      _react2.default.createElement(
        'span',
        { className: 'label', 'aria-hidden': 'true' },
        active ? 'ON' : 'OFF'
      ),
      _react2.default.createElement(
        'div',
        { className: 'toggle' },
        children
      )
    ),
    _react2.default.createElement(
      _reactIntl.FormattedMessage,
      { id: localeKey },
      function (message) {
        return _react2.default.createElement(
          _baseScreenReaderMessage2.default,
          null,
          message
        );
      }
    )
  );
};

ToggleSwitch.displayName = 'ToggleSwitch';

ToggleSwitch.propTypes = {
  active: _react.PropTypes.bool.isRequired,
  handleClick: _react.PropTypes.func.isRequired,
  className: _react.PropTypes.string,
  activeLocaleKey: _react.PropTypes.string.isRequired,
  inactiveLocaleKey: _react.PropTypes.string.isRequired,
  children: _react.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node]).isRequired
};

exports.default = ToggleSwitch;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-toggle-switch/lib/components/ToggleSwitch.component.js
// module id = 1360
// module chunks = 1